module.exports = __webpack_public_path__ + "static/media/title-header.24f6844d.webp";